import { render } from "./report_logo.vue?vue&type=template&id=691a3702&scoped=true"
import script from "./report_logo.vue?vue&type=script&lang=js"
export * from "./report_logo.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-691a3702"

export default script